// import { delCosObject } from '../../../../../gloab/cos';
import { arrUnique, postfixFun } from '@/utils/util';
import {
  EyaoSaaSSelectMaterialApi,
  EyaoSaaSDeleteMaterialApi,
  EyaoSaaSUpdateMaterialPubRefApi,
} from '@/api/releaseManagement';
// 排名卡片和排名详情之间的事件处理
const mixinTable = {
  data() {
    return {
      search: '', // 搜索
      publicSelect: '', // 公众号选择
      agentSelect: '', // 企业应用选择
      tableData: [], // 表格数据
      /** 备份
       * 请求数据=>tableData备份到tableDataTemp
       * 取消=>通过id, 找到tableDataTemp对应值覆盖到tableData对应值
       * 保存/删除=>重新请求数据
       */
      tableDataTemp: [],
      tableCurPage: 1, // 当前页
      tablePageSize: 10, // 每页条数
      tableTotal: 0, // 总条数
      tableLoading: false, // 表格加载
      uploadShow: false, // 是否显示上传组件
      rowTemp: {}, // 暂存row数据(如删除操作)
      delDialogVisible: false, // 删除action弹窗
      // 播放
      playSrc: '', // 播放路径
      playDialogVisible: false, // 播放弹窗
    };
  },
  // keep-alive进入
  activated() {},
  // keep-alive离开(隐藏RankCardDetail, 显示页面其他组件)
  deactivated() {},
  computed: {
    publicList() {
      return this.$store.getters['user/getPublishList'];
    },
    // 应用管理
    agentList() {
      return this.$store.state.user.managerLogin.agent_list || [];
    },
  },
  mounted() {
    this.tablePageSize = this.g_pageSizeDefault;
    this.init();
  },
  methods: {
    // 初始化
    init() {
      this.getTaleData();
    },
    // 查询素材库列表
    async getTaleData(
      query = {
        page_index: this.tableCurPage,
        page_size: this.tablePageSize,
        mate_type: this.file_type,
        keyword: this.search,
        appids: this.publicSelect,
        agent_ids: this.agentSelect,
      },
    ) {
      this.tableLoading = true;
      try {
        const res = await EyaoSaaSSelectMaterialApi({
          page_index: query.page_index, // 分页码
          page_size: query.page_size, // 每页条数
          mate_type: query.mate_type, // 素材类型 图片（1）、语音（2）、视频（3）
          keyword: query.keyword, // 搜索图片名称
          appids: query.appids ? [query.appids.value] : undefined, // 搜索公众号ids
          agent_ids: query.agent_ids ? [query.agent_ids.value] : undefined, // 搜索公众号ids
        });
        this.tableTotal = res.total;

        const list = [...res.mate_list];
        // console.log(list);
        // const ids = list.map((item) => item.mate_id);
        // console.log(ids);
        // GetMaterialByIDs({ mate_ids: ids }).then((res) => {
        //   console.log(res);
        // });
        for (let i = 0; i < list.length; i++) {
          const e = list[i];
          e.show = false;
          e.cos_url = e.mate_data;
          const { prefix, postfix } = postfixFun(e.mate_name);
          e.prefix = prefix;
          e.postfix = postfix;
        }
        this.tableData = list;
        this.tableDataTemp = list;
      } catch (error) {
        this.$message.error(error.message);
        this.tableLoading = false;
      }
      this.tableLoading = false;
    },
    // 搜索
    handleSearch() {
      this.tableCurPage = 1;
      this.getTaleData();
    },
    // 切换页触发事件
    currentChangeFun(e) {
      this.tableCurPage = e;
      this.getTaleData();
    },
    // 切换每页显示条目个数
    handleSizeChange(e) {
      this.tablePageSize = e;
      this.getTaleData();
    },
    /** 操作
     * @description: 表格操作事件
     * @param {string} action 操作名称
     * @param {object} row 操作行数据
     * @return {*} void
     */
    async actionFun({ action, row }) {
      const curTableData = JSON.parse(JSON.stringify(this.tableData));
      const curtableDataTemp = JSON.parse(JSON.stringify(this.tableDataTemp));
      switch (action) {
        case '修改':
          curTableData.forEach((e) => {
            if (e.mate_id === row.mate_id) {
              e.show = !row.show;
              this.tableData = curTableData;
            }
          });
          curTableData.forEach((e) => {
            // 列表只能出现一个编辑
            if (e.mate_id !== row.mate_id && e.show) {
              // 取消=>curtableDataTemp覆盖tableData
              curtableDataTemp.forEach((e1, i) => {
                if (e1.mate_id === e.mate_id) {
                  this.$set(this.tableData, i, e1);
                }
              });
            }
          });
          break;
        case '删除':
          // 保存/删除=>重新请求数据
          this.tableLoading = true;
          try {
            const res = await EyaoSaaSDeleteMaterialApi({
              mate_id: row.mate_id,
            });
            if (res) {
              // 服务器删除成功后再删除COS桶文件
              this.delCosHandle(row);
              this.getTaleData();
              this.$message.success('删除成功');
            } else {
              this.$message.error('删除失败, 请稍后再试');
            }
          } catch (error) {
            this.$message.error(error.message);
          }
          this.tableLoading = false;
          break;
        case '保存':
          {
            // 保存/删除=>重新请求数据
            if (!row.mate_name) {
              this.$message.warning('请输入名称');
              return;
            }
            if (!row.apps.length && !row.agents.length) {
              this.$message.warning('请至少选择一个公众号或企业应用');
              return;
            }
            // if ([2, 3].includes(row.mate_type)) {
            //   for (const item of curtableDataTemp) {
            //     if (item.mate_id === row.mate_id) {
            //       if (item.apps.length === 0 && item.agents.length !== 0 && row.apps.length !== 0) {
            //         this.$message.warning('该素材的文件大小不适用于公众号');
            //         return;
            //       }
            //     }
            //   }
            // }

            this.tableLoading = true;
            try {
              const res = await EyaoSaaSUpdateMaterialPubRefApi({
                mate_info: {
                  mate_id: row.mate_id,
                  mate_type: row.mate_type,
                  mate_name: row.prefix + row.postfix,
                  mate_data: row.mate_data,
                  apps: row.apps,
                  agents: row.agents,
                },
              });
              if (!res.error) {
                this.getTaleData();
                this.$message.success('保存成功');
              } else {
                this.$message.error('保存失败, 请稍后再试');
                this.tableLoading = false;
              }
            } catch (error) {
              this.tableLoading = false;
              this.$message.error(error.message);
            }
          }
          break;
        case '取消':
          // 取消=>curtableDataTemp覆盖tableData
          curtableDataTemp.forEach((e, i) => {
            if (e.mate_id === row.mate_id) {
              this.$set(this.tableData, i, e);
            }
          });
          break;
        default:
          break;
      }
    },
    /** 可删除标签组件 删除
     * @description: 可删除标签组件的删除事件, 根据id和标签的索引删除
     * @param {object} row 操作行的数据
     * @param {number} index 索引
     * @return {*} void
     */
    emitDeleteTagDec({ row, index }) {
      this.tableData.forEach((e) => {
        if (e.mate_id === row.mate_id) {
          e.apps.splice(index, 1);
        }
      });
    },
    /** 可删除标签组件 新增
     * @description: 循环添加 如果列表已经有了, 不添加
     * @param {object} row 操作行的数据
     * @param {Array[object]} e: [{label:'显示名称',value:'id值'},...]
     * @return {*} void
     */
    emitDeleteTagAdd({ row, e }) {
      // console.log({ row, e });
      this.tableData.forEach((item1) => {
        if (item1.mate_id === row.mate_id) {
          item1.apps = [];
          e.forEach((item2) => {
            item1.apps.push({
              app_id: item2.value,
              app_name: item2.label,
            });
          });
          // 对象数组去重
          item1.apps = arrUnique(item1.apps, 'app_id');
        }
      });
    },
    /** 可删除标签组件 删除
     * @description: 可删除标签组件的删除事件, 根据id和标签的索引删除
     * @param {object} row 操作行的数据
     * @param {number} index 索引
     * @return {*} void
     */
    emitDeleteTagDec2({ row, index }) {
      console.log(1123);
      this.tableData.forEach((e) => {
        if (e.mate_id === row.mate_id) {
          e.agents.splice(index, 1);
        }
      });
    },
    /** 可删除标签组件 新增
     * @description: 循环添加 如果列表已经有了, 不添加
     * @param {object} row 操作行的数据
     * @param {Array[object]} e: [{label:'显示名称',value:'id值'},...]
     * @return {*} void
     */
    emitDeleteTagAdd2({ row, e }) {
      console.log(row);
      this.tableData.forEach((item1) => {
        if (item1.mate_id === row.mate_id) {
          console.log(1);
          item1.agents = [];
          e.forEach((item2) => {
            item1.agents.push({
              agent_id: item2.value,
              agent_name: item2.label,
            });
          });
          // 对象数组去重
          console.log(item1);
          item1.agents = arrUnique(item1.agents, 'agent_id');
        }
      });
    },
    /** 素材库的上传图片/视频/音频 回调
     * @description: 返回取消列表无操作, 保存刷新表格
     * @param {*} val 'back'(返回)  'save'(保存)
     * @return {*}
     */
    emitMaterialUpload(val) {
      this.uploadShow = false;
      if (val === 'save') {
        this.tableCurPage = 1;
        this.search = '';
        this.getTaleData();
      }
    },
    handleUpload(e) {
      switch (e) {
        case 1:
          this.g_tourl(`/saas/materialManagement/material-img-upload.html`);
          break;
        case 2:
          this.g_tourl(`/saas/materialManagement/material-video-upload.html`);
          break;
        case 3:
          this.g_tourl(`/saas/materialManagement/material-audio-upload.html`);
          break;
        default:
          break;
      }
    },
    // 删除COS桶文件
    async delCosHandle(row) {
      try {
        const res = await this.delCosObject({ imgCosKey: row.cos_url }); // delCosObject({ imgCosKey: row.cos_url });
        if (res) {
          console.log('COS删除成功');
        } else {
          console.log('COS删除失败');
        }
      } catch (error) {
        console.log('COS请求失败');
      }
    },
    // 播放
    handlePlay(e) {
      this.playSrc = e;
      this.playDialogVisible = true;
    },
    // 关闭播放
    handleClose() {
      if (document.getElementById('play').pause) {
        document.getElementById('play').pause();
      }
      this.playDialogVisible = false;
    },
  },
};

export { mixinTable };
